import { getBaseUrl } from '../../maps/apiEnvironmentMap';
import { ExtraFields, LockerPosition } from '../microservices';

const API_KEY = process.env.REACT_APP_API_KEY;

export class LockerPositionRequestPUT {
  readonly method: string = 'locker-positions';
  public buildURL(lockerPosition: number) {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}/${lockerPosition}`;
  }
  public generateContent(
    id: number,
    lockerRackId: number,
    row: string,
    column: string,
    lockerPositionTypeId: number,
    lockerPositionStatusId: number,
    cid: string,
    sid: string,
    isActive: boolean
  ) {
    const params: LockerPositionPayload = {
      id: id,
      lockerRackId: lockerRackId,
      row: row,
      column: column,
      lockerPositionTypeId: lockerPositionTypeId,
      lockerPositionStatusId: lockerPositionStatusId,
      extraFields: {
        cid: cid,
        sid: sid,
      },
      isActive: isActive,
    };
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}
type LockerPositionPayload = {
  id: number;
  lockerRackId: number;
  row: string;
  column: string;
  lockerPositionTypeId: number;
  lockerPositionStatusId: number;
  extraFields: ExtraFields;
  isActive: boolean;
};
export type LockerPositionResponsePUT = {
  status: string;
  message: string;
  data: {
    lockerPosition: LockerPosition;
  };
};
